import { render, staticRenderFns } from "./DeckTerms.vue?vue&type=template&id=19283304&"
import script from "./DeckTerms.vue?vue&type=script&lang=js&"
export * from "./DeckTerms.vue?vue&type=script&lang=js&"
import style0 from "./DeckTerms.vue?vue&type=style&index=0&id=19283304&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports